<template>
  <ux-form
    ref="form"
    :data="formData"
    width="600px"
    :colon="true"
    :rules="rules"
    label-width="70px"
    data-automation="modify"
  >
    <ux-form-item v-if="this.formData.message" :label="$t('HT.modify.message')" prop="message">
      <ux-input v-model="formData.message" :disabled="true"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.userName')" prop="title">
      <ux-input v-model="formData.title"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.phone')" prop="phone">
      <ux-input v-model="formData.phone" :maxlength="11"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.sales')" prop="sales">
      <ux-input v-model="formData.sales"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.engineer')" prop="engineer">
      <ux-input v-model="formData.engineer"></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxConn')" prop="max_conn">
      <ux-input
        v-model="formData.max_conn"
        :maxlength="6"
        :placeholder="$t('HT.addLicense.maxConn.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.maxHosts')" prop="max_hosts">
      <ux-input
        v-model="formData.max_hosts"
        :maxlength="3"
        :placeholder="$t('HT.addLicense.maxHosts.placeholder')"
      ></ux-input>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.expireDate')" prop="expire_date">
      <ux-radio v-model="formData.expire_date" :options="$opt.expire_date"></ux-radio>
    </ux-form-item>
    <ux-form-item :label="$t('HT.addLicense.date')" v-if="supervisor && formData.expire_date === 0">
      <ux-date v-model="formData.date" top></ux-date>
    </ux-form-item>
  </ux-form>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          title: '', // 客户名
          phone: '', // 联系方式
          sales: '', // 销售
          engineer: '', // 技术支持
          max_conn: '', // 最大连接数
          max_hosts: '', // 最大网卡数
          expire_date: '', // 有效期
          date: ''
        };
      }
    },
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },

  data() {
    return {
      formData: JSON.parse(JSON.stringify(this.data)),
      supervisor: this.user.supervisor,
      rules: this.$rul.modify()
    };
  },

  computed: {
    /**
     * 时间转换
     */
    time() {
      return this.$uxSdk.time;
    }
  },

  created() {
    let phone = this.formData.extension && JSON.parse(this.formData.extension).phone; // 从extension里得到phone字段
    this.$set(this.formData, 'phone', phone || '');
    this.formatterTime(this.formData.expire_date);
    this.formData.expire_date = 0;
  },

  methods: {
    /**
     * 格式化时间
     */
    formatterTime(params) {
      this.formData.date = this.time.format('YYYY-MM-DD', params * 1000);
      return this.formData.date;
    }
  }
};
</script>
